import React, { useEffect, useRef } from 'react';
import { toast } from 'react-toastify';
import { dispatch, useSelector } from '../../../redux/store';
import { hidePOSCloseTab, hidePOSTab, setTransferDialogOpen } from '../../../redux/slices/posRedux/posRedux';
import { getPosLifecycleTransition } from './posSessionLifecycle';

export default function POSSessionLifecycleGuard() {
  const { sessionContext, sessionContextResolved } = useSelector((state) => state?.pos);
  const previousContext = useRef(null);
  const initialized = useRef(false);

  useEffect(() => {
    if (!sessionContextResolved) return;
    if (!initialized.current) {
      initialized.current = true;
      previousContext.current = sessionContext;
      return;
    }

    const transition = getPosLifecycleTransition(previousContext.current, sessionContext);
    previousContext.current = sessionContext;
    if (!transition) return;

    dispatch(hidePOSTab());
    dispatch(hidePOSCloseTab());
    dispatch(setTransferDialogOpen(false));
    toast.warning(transition.message);
  }, [sessionContext, sessionContextResolved]);

  return null;
}
